import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceGroupData} from "../../customer-instance-group/customer-instance-group.data";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";

export class PlanConfig {
    name: string;
}

@Component({
    selector: "fhm-customer-instance-group-select-control",
    templateUrl: "./customer-instance-group-select-control.component.html",
    styleUrls: ["./customer-instance-group-select-control.component.scss"],
    standalone: false
})
export class CustomerInstanceGroupSelectControlComponent implements OnChanges, OnInit {

    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    @Input() label: string;

    @Input() disabled: boolean;

    @Input() customerInstanceId: string;
    @Input() venueId: string;

    public selectedValue: any;

    public options: any[] = [];

    constructor( private http: HttpClient,
                 private auth: AuthApiService,
                 private errorHandler: ErrorHandlerService) {
    }

    ngOnInit(): void {
        this.http.get<CustomerInstanceGroupData[]>("/fonzie/customer-instance-group", {headers: this.auth.getHttpHeaderOptions()})
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe(data => {
                data.forEach(instanceGroup => {
                    const record = {label: instanceGroup.groupId, value: instanceGroup.id};
                    this.options.push(record);

                    if (instanceGroup.id === this.value) {
                        this.selectedValue = record;
                    }
                });
            });
    }

    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
